const logger = () => {
  const background = '#EFEFEF'
  let start
  let last

  const isEnabled = () => {
    return process.env.NODE_ENV === 'development'
  }
  const getIcon = type => {
    switch (type) {
      case 'info':
        return '\u2139'
      case 'error':
        return '\u274C'
      case 'success':
        return '\u2714'
      default:
        return ''
    }
  }
  const getColor = type => {
    switch (type) {
      case 'info':
        return '#999999'
      case 'error':
        return 'red'
      case 'success':
        return 'green'
      default:
        return 'blue'
    }
  }

  const log = (type, message = '', args = []) => {
    if (!isEnabled()) return
    if (!start) {
      start = new Date().getTime()
      last = start
    }
    const now = new Date().getTime()
    const color = getColor(type)
    const icon = getIcon(type)
    console.log(
      `%c ${icon} ${message}`,
      `background: ${background}; color: ${color}`,
      `${now - start}ms`
    )

    args.forEach(arg => {
      console.log('%c ----> ', `background: ${background}; color: ${color}`, arg)
    })

    last = now
  }

  const success = (message, args) => {
    log('success', message, args)
  }

  const error = (message, args) => {
    log('error', message, args)
  }

  const info = (message, args) => {
    log('info', message, args)
  }

  const reset = () => {
    start = null
  }

  return {
    success,
    error,
    info,
    log,
    reset,
  }
}

export default logger()



// WEBPACK FOOTER //
// public/content/themes/farrach/src/js/helpers/log.js